import React from 'react';
import { Typography, Link } from '@material-ui/core';

const Copyright = () => {
    return (
        <Typography variant="body2" color="textSecondary" align="center">
            Copyright ©&nbsp;
            <Link
                color="inherit"
                href="https://mustapha-el-mezziouy.vercel.app/"
                style={{ color: '#0295eb' }}
                target="_blank"
                rel="noreferrer"
            >
                Mustapha EL-MEZZIOUY
            </Link>
            &nbsp;
            {new Date().getFullYear()}
        </Typography>
    )
}

export default Copyright
